import React from "react";
import { highRiskIcon, lowRiskIcon, moderateRiskIcon, reallyHighRiskIcon, reallyLowRiskIcon } from "../riskAssessment/riskIndicator/riskIcons";
import { riskLevelBucketIndex } from "./riskLevelColor";

// The severity chevrons are a fixed 5-step set (Very low → Very high) with their original fixed fills (teal /
// yellow / pink). We pick one by the same bucket index that drives the chip color, so a level on any configured
// scale (3..6) gets a chevron consistent with its color.
const iconsLowToHigh = [reallyLowRiskIcon, lowRiskIcon, moderateRiskIcon, highRiskIcon, reallyHighRiskIcon];

export function getRiskLevelIcon(level: number, scale: number): React.ReactNode {
    return iconsLowToHigh[riskLevelBucketIndex(level, scale)];
}
